module.exports = __webpack_public_path__ + "static/Truck34-9d0c5acd5010c96ae54f9c03fb8259ec.png";